export type { ImageBaseProps, Ratio } from '@sberdevices/plasma-core';

export { Image } from './Image';
export type { ImageProps } from './Image';
